"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = FileFieldCell;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _cvsFieldContainer = _interopRequireDefault(require("./styled/cvsFieldContainer"));

var _cancelIcon = _interopRequireDefault(require("./styled/cancelIcon"));

function FileFieldCell(_ref) {
  var value = _ref.value;

  if (value) {
    return value;
  }

  return /*#__PURE__*/_react["default"].createElement(_cvsFieldContainer["default"], null, "Not assigned yet", /*#__PURE__*/_react["default"].createElement(_cancelIcon["default"], null));
}

FileFieldCell.propTypes = {
  value: _propTypes["default"].string.isRequired
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-rainbow-components/components/ImportRecordsFlow/stepThree/fileFieldCell.js
// module id = Zc53
// module chunks = 0